// layout/AppLayout.jsx
import { useState } from "react";
import {
  Outlet,
  // useLocation 
} from "react-router-dom";
import {
  Box,
  Container,
  IconButton,
  Typography,
  AppBar,
  Stack,
} from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import Sidebar, { SIDEBAR_OPEN_WIDTH } from "../components/Sidebar";
// import Footer from "../components/Footer";

export default function AppLayout() {
  // const location = useLocation();
  // const hideFooter = location.pathname === "/login";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Desktop sidebar width
  const [sidebarWidth, setSidebarWidth] = useState(SIDEBAR_OPEN_WIDTH);

  // Mobile sidebar state
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleMobileOpen = () => setMobileOpen(true);
  const handleMobileClose = () => setMobileOpen(false);

  return (
    <Box sx={{ display: "flex", width: "100%"
      // ,border:"green solid 1px", 
     }}>

      {/* SIDEBAR */}
      <Sidebar
        onToggle={setSidebarWidth}
        mobileOpen={mobileOpen}
        onMobileClose={handleMobileClose}
      />

      {/* MAIN CONTENT */}
      <Box
        sx={{ 
          width: isMobile ? `calc(100% - ${7}px)` : `calc(100% - ${sidebarWidth + 7}px)`,
          ml: isMobile ? 0 : `${sidebarWidth}px`,
          transition: isMobile ? "none" : "margin 0.25s ease",
          // background: "#f4f4f4",
          // border:"blue solid",
           minHeight: "calc(100vh - 8px)",
        }}
      >
        {/* MOBILE TOP BAR */}
        {isMobile && (
          <AppBar
            position="fixed"
            elevation={1}
            sx={{ 
              left: 0,
              width: "100%",
              background:
                "linear-gradient(90deg, rgba(45,45,45,.98), rgba(30,15,50,.95))",
            }}
          >
            <Box
              sx={{
                height: 56,
                display: "flex",
                alignItems: "center",
                px: 2,
              }}
            >
              <IconButton
                onClick={handleMobileOpen}
                sx={{ color: "#fff", mr: 1 }}
              >
                <MenuIcon />
              </IconButton>
              <Stack direction="column" spacing={0} alignItems="center">
                <Stack direction="row" spacing={0} alignItems="center">
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      letterSpacing: 1,
                      background:
                        "linear-gradient(90deg,#bb86fc,#e040fb,#bb86fc)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Betania
                  </Typography>
                  <Typography variant="h5"
                    sx={{
                      fontWeight: 700,
                      letterSpacing: 1,
                      background:
                        "#dddddd",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}>Hub</Typography>

                </Stack>

              </Stack>
            </Box>
          </AppBar>
        )}

        <Container
          disableGutters 
          maxWidth={false} 
          sx={{ 
            width: `calc(100% - ${2}px)`,
            height: isMobile ? "calc(100vh - 66px)" : "calc(100vh - 10px)",
            py: isMobile ? 8 : 2,
            px: isMobile ? 2 : 2,
          }}
        > 
          <Outlet />
        </Container>
 
      </Box>
    </Box>
  );
}
